import type { User } from '../types';
import {
  canAccessImsPlatform,
  canAccessVmsPlatform,
  canUseBothPlatforms,
  getImsDefaultLandingPath,
  getVmsDefaultLandingPath,
} from './vmsRole';

export type PlatformId = 'ims' | 'vms';

/** Dual-platform users — show in-header platform switcher (same gate as system selection). */
export function shouldShowPlatformSwitcher(user: User | null | undefined): boolean {
  return canUseBothPlatforms(user);
}

/**
 * Navigate target after choosing a platform — mirrors `SystemSelection.handleSystemSelect`.
 * Persists `selectedSystem` in sessionStorage for subsequent redirects.
 */
export function getPlatformSwitchPath(
  system: PlatformId,
  user: User | null | undefined
): string {
  if (system === 'ims') {
    if (!canAccessImsPlatform(user)) {
      return getVmsDefaultLandingPath(user);
    }
    sessionStorage.setItem('selectedSystem', 'ims');
    return getImsDefaultLandingPath(user);
  }

  if (!canAccessVmsPlatform(user)) {
    return getImsDefaultLandingPath(user);
  }
  sessionStorage.setItem('selectedSystem', 'vms');
  return getVmsDefaultLandingPath(user);
}
